import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import AddRouter from '@/vuepage/AddRouter';
import utils from '@/jslibs/utils' // getToken from cookie


NProgress.configure({
	showSpinner: false
}) // NProgress Configuration



import UserManage from './modules/user-manage';
import CommonManage from './modules/common-manage.js'
import CourseManage from './modules/course-manage.js'
import TrainingManage from './modules/training-manage.js'
import OrdersManage from './modules/orders-manage.js'
import MarketingManage from './modules/marketing-manage.js'
import ViewsManage from './modules/views-manage.js'
import StaticsManage from './modules/statics-manage.js'
import AuthsManage from './modules/auths-manage.js'



const Login = () => import('@/vuepage/Login');
const Index = () => import('@/vuepage/Index');
Vue.use(Router);

const whiteList = ['/login'] // no redirect whitelist

var children = [...UserManage, ...CommonManage, ...CourseManage, ...TrainingManage, ...OrdersManage, ...
	MarketingManage, ...ViewsManage,...StaticsManage,...AuthsManage
];

const router = new Router({
	routes: [{
		path: '',
		redirect: '/login'
	}, {
		path: '/login',
		component: Login
	}, {
		path: '/index',
		component: Index,
		children
	}, {
		path: '/addrouter',
		component: AddRouter
	}]
	// mode: 'history',
});


router.beforeEach((to, from, next) => {
	children = [...UserManage];
	NProgress.start()
	if (utils.getCookie("authorization")) {
		// 已登录且要跳转的页面是登录页
		if (to.path === '/login') {
			//console.log("login")
			next()
			NProgress.done()
		} else {
			console.log(utils.getCookie('authorization'))
			if (utils.getCookie('authorization') == null) {
				console.log("ddd")
				next({
					path: '/login'
				})
				NProgress.done()
				// if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
				//   store.dispatch('GetInfo').then(() => { // 拉取user_info
				//     // 动态路由，拉取菜单
				//     loadMenus(next, to)
				//   }).catch(() => {
				//     store.dispatch('LogOut').then(() => {
				//       location.reload() // 为了重新实例化vue-router对象 避免bug
				//     })
				//   })
				// // 登录时未拉取 菜单，在此处拉取
				// } else if (store.getters.loadMenus) {
				//   // 修改成false，防止死循环
				//   store.dispatch('updateLoadMenus')
				//   loadMenus(next, to)
			} else {
				next()
			}
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
			next()
		} else {
			next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
			NProgress.done()
		}
	}

})

export const filterAsyncRouter = (routers, isRewrite = false) => { // 遍历后台传来的路由字符串，转换为组件对象
	return routers.filter(router => {
		if (isRewrite && router.children) {
			router.children = filterChildren(router.children)
		}
		if (router.component) {
			if (router.component === 'Layout') { // Layout组件特殊处理
				router.component = Layout
			} else if (router.component === 'ParentView') {
				router.component = ParentView
			} else {
				const component = router.component
				router.component = loadView(component)
			}
		}
		if (router.children && router.children.length) {
			router.children = filterAsyncRouter(router.children, router, isRewrite)
		}
		return true
	})
}

router.afterEach(() => {
	NProgress.done() // finish progress bar
})

export default router;